export default Object.freeze({
  INFOSCREEN: 'infoscreen',
  OPERATOR_WORKSPACE: 'operator_workspace',
  REGISTRATOR: 'registrator',
  WINDOWSCREEN: 'windowscreen'
});
